import {
   Select as MantineSelect,
   SelectProps as MantineSelectProps,
} from '@mantine/core'
import styles from './Select.module.scss'
import cn from 'classnames'

export const Select = ({
   checkIconPosition = 'right',
   allowDeselect= false,
   nothingFoundMessage = 'No results found',
   ...props
}: MantineSelectProps) => {
   return (
      <MantineSelect
         checkIconPosition={checkIconPosition}
         allowDeselect={allowDeselect}
         nothingFoundMessage={nothingFoundMessage}
         classNames={{
            input: cn(styles['text-input']),
            label: 'text-white/90 font-medium mb-1.5',
            dropdown: 'bg-black rounded-lg p-2 z-[99999]',
            description: 'pt-0.5',
         }}
         inputWrapperOrder={['label', 'input', 'description', 'error']}
         {...props}
      />
   )
}
